<template>
    <AppFileUploadModal
        id="usage-upload-modal"
        :title="$t('Usage file upload')"
        :url="requestPath"
        @update:response="redirect"
    />
</template>

<script setup>
import AppFileUploadModal from "../../shared/AppFileUploadModal.vue";
import {computed, onMounted, ref} from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";

const { uri } = defineProps({
    uri: {
        type: String,
        default: 'uploads',
    },
})

const requestPath = computed(() => '/api/' + uri)

function redirect(response) {
    if (response.data.id) {
        window.location = '/uploads';
    }
}

</script>
